import React from "react";
import {
  Typography,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Divider,
} from "@mui/material";
import { CheckCircle as CheckCircleIcon } from "@mui/icons-material";
import { EvacuationStep } from "../../types/evacuation";

interface EvacuationPlanStepsProps {
  steps: EvacuationStep[];
}

export const EvacuationPlanSteps: React.FC<EvacuationPlanStepsProps> = ({
  steps,
}) => {
  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Steg i checklistan
        </Typography>
        <Divider sx={{ mb: 2 }} />
        <List>
          {steps.map((step, index) => (
            <ListItem
              key={step.id || index}
              sx={{ border: "1px solid #e0e0e0", mb: 1, borderRadius: 1 }}
            >
              <ListItemIcon>
                <CheckCircleIcon color="primary" />
              </ListItemIcon>
              <ListItemText
                primary={`Steg ${step.order || index + 1}`}
                secondary={step.description}
                secondaryTypographyProps={{ variant: "body1" }}
              />
            </ListItem>
          ))}
        </List>
      </CardContent>
    </Card>
  );
};
